import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ApiService } from '../services/api.service';
import { AuthService } from '../services/auth.service';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-verify-mobile-number',
    imports: [CommonModule, FormsModule, FontAwesomeModule, ReactiveFormsModule],
    templateUrl: './verify-mobile-number.component.html',
    styleUrl: './verify-mobile-number.component.css'
})
export class VerifyMobileNumberComponent implements OnInit, OnDestroy {
  otpForm: FormGroup;
  error: string = '';
  success: string = '';
  isSubmitting = false;
  mobileNumber: string = ''; 
  timer: number = 100;
  private intervalId: any;

  constructor(private http: HttpClient,
              private router: Router,
              private apiService: ApiService,
              private authService: AuthService,
              private fb: FormBuilder,
              private toastr: ToastrService
  ) {
    this.otpForm = this.fb.group({
      otp: ['', [Validators.required, Validators.pattern(/^\d{6}$/)]],
    });
  }

  ngOnInit(): void {
    // Automatically send OTP when component loads
    this.sendOTP()
     this.startCountdown();
  }

  startCountdown() {
    this.timer = 100;
    if (this.intervalId) clearInterval(this.intervalId);

    this.intervalId = setInterval(() => {
      if (this.timer > 0) {
        this.timer--;
      } else {
        clearInterval(this.intervalId);
      }
    }, 1000);
  }

  sendOTP() {

    this.apiService.sendMobileVerificationOTP({}).subscribe({
      next: (res) => {
        this.mobileNumber = res['mobile_number'];
        this.toastr.success('OTP sent successfully', 'Success')
        // Reset OTP input fields
        if (this.otpControls && Array.isArray(this.otpControls)) {
          this.otpControls.forEach(ctrl => ctrl.setValue(''));
        }

        this.startCountdown();
      },
      error: (err) => {
         this.toastr.error(err.error?.detail || 'Failed to send OTP', 'Error')

      },
    });
  }
   
  verifyOTP() {
  if (this.otpForm.invalid) return;

  this.isSubmitting = true;
  this.apiService.verifyMobileOTP(this.otpForm.value).subscribe({
    next: () => {
      this.authService.saveToLocalStorage();
        this.authService.updateStoredUser({is_mobile_verified: true});
      this.toastr.success('OTP Verified successfully', 'Success')
      this.router.navigate(['/dashboard']);
    },
    error: (err) => {
      this.toastr.error(err.error?.detail || 'Verification failed', 'Error')
      this.isSubmitting = false;
    }
  });
}

otpControls = Array.from({ length: 6 }, () => new FormControl(''));

onOtpInput(event: any, idx: number) {
  const input = event.target;
  const value = input.value;
  if (value.length === 1 && idx < this.otpControls.length - 1) {
    input.nextElementSibling?.focus();
  }
  this.updateOtpForm();
}

onOtpKeyDown(event: KeyboardEvent, idx: number) {
  const input = event.target as HTMLInputElement;
  if (event.key === 'Backspace' && !input.value && idx > 0) {
    (input.previousElementSibling as HTMLInputElement | null)?.focus();
  }
}

updateOtpForm() {
  const otp = this.otpControls.map(ctrl => ctrl.value).join('');
  this.otpForm.get('otp')?.setValue(otp);
}

ngOnDestroy(): void {
  if (this.intervalId) {
    clearInterval(this.intervalId);
  }
}

}
